export default __webpack_public_path__ + "static/3-4953c4a245056a5d67a998a887798952.jpeg";